import {
  PARTNER_AGENT_LEGACY_PARAM,
  PARTNER_AGENT_PARAM,
} from "@/lib/partners/constants"
import { normalizePartnerAgentCode } from "@/lib/partners/partner-agent-cookie"

type AgentQuery = Partial<
  Record<typeof PARTNER_AGENT_PARAM | typeof PARTNER_AGENT_LEGACY_PARAM, string | string[] | undefined>
>

function firstQueryValue(value: string | string[] | undefined): string | null {
  if (typeof value === "string") return value
  if (Array.isArray(value) && typeof value[0] === "string") return value[0]
  return null
}

/** `?agente=` vence; `?corretor=` permanece para links já distribuídos. */
export function readPartnerAgentCodeFromSearchParams(params: {
  get(name: string): string | null
}): string | null {
  return (
    normalizePartnerAgentCode(params.get(PARTNER_AGENT_PARAM)) ??
    normalizePartnerAgentCode(params.get(PARTNER_AGENT_LEGACY_PARAM))
  )
}

export function readPartnerAgentCodeFromPageQuery(query: AgentQuery): string | null {
  return (
    normalizePartnerAgentCode(firstQueryValue(query[PARTNER_AGENT_PARAM])) ??
    normalizePartnerAgentCode(firstQueryValue(query[PARTNER_AGENT_LEGACY_PARAM]))
  )
}
